import ninegrid from "../index.js";

export class ngCellManager
{
	#owner;
	#oldCurrentCell;
	#newCurrentCell;
	#oldMatrixRow;
	#newMatrixRow;
	#oldCol;
	#newCol;
	#newCellIndex;
	#oldCellIndex
	#oldBind;
	#newBind;

	constructor(owner) {

		this.#owner = owner;
		//this.selector = new ngCellSelector(owner);
		this.#oldMatrixRow = -1;
		this.#newMatrixRow = -1;
		this.#oldCol = -1;
		this.#newCol = -1;

		this.resetEvent();
	};

	get matrixRow() {
		return this.#newMatrixRow;
	};
	get col() {
		return this.#newCol;
	};
	
	get #matrixRow() {
		return this.#newMatrixRow;
	};
	set #matrixRow(v) {
		this.#oldMatrixRow = this.#newMatrixRow;
		this.#newMatrixRow = parseInt(v);
	}
	
	get #cellIndex() {
		return this.#newCellIndex;
	};
	set #cellIndex(v) {
		this.#oldCellIndex = this.#newCellIndex;
		this.#newCellIndex = parseInt(v);
	}
	get #col() {
		return this.#newCol;
	};
	set #col(v) {
		this.#oldCol = this.#newCol;
		this.#newCol = parseInt(v);
	}
	
	get #bind() {
		return this.#newBind;
	};
	set #bind(v) {
		this.#oldBind = this.#newBind;
		this.#newBind = v;
	}
	
	get currentCell() {
		return this.#newCurrentCell;
	};
	set currentCell(v) {
		if (!v) return;

		//var td = e.target.closest("th,td");
		this.#oldCurrentCell = this.#newCurrentCell;
		this.#newCurrentCell = v;

		v.focus();

		var tr = v.closest("tr");
		
		this.#matrixRow	= parseInt(tr.dataset.row) * this.#owner.template.length + tr.sectionRowIndex % this.#owner.template.length;
		this.#col		= parseInt(v.dataset.col);
		this.#cellIndex	= v.cellIndex;
		this.#bind		= v.dataset.bind;

		if (!tr.closest("tbody.fixed")) this.#owner.row.at = v.dataset.row;
		
		this.#owner.selection.selectCell(this.#matrixRow, this.#col);
		
		const cell			= v;
		const row			= parseInt(cell.dataset.row);
		const subrow		= parseInt(cell.dataset.matrixRow) % parseInt(cell.dataset.row);
		const col			= parseInt(cell.dataset.col);
		const cellIndex		= cell.cellIndex;
		const oldrow		= parseInt(this.#oldMatrixRow / this.#owner.template.length);
		const oldsubrow		= parseInt(this.#oldMatrixRow) % parseInt(this.#oldMatrixRow / this.#owner.template.length);
		const oldcol		= this.#oldCol;
		const oldCellIndex	= this.#oldCellIndex;
		
		if (row != oldrow || subrow != oldsubrow || col != oldcol) {
			const customEvent		= new CustomEvent(ninegrid.EVENT.CELL_POS_CHANGED, { bubbles: true, detail: {} });
	 		customEvent.col			= col;
			customEvent.cellIndex	= cellIndex;
	 		customEvent.row			= row;
			customEvent.subrow		= subrow;
			customEvent.bind		= cell.dataset.bind;
			customEvent.prev		= {
				col			: oldcol,
				cellIndex	: oldCellIndex,
				col			: oldcol,
	 			row			: oldrow,
				subrow		: oldsubrow,
				bind		: this.#oldBind,
			}
	 		
	 		this.#owner.dispatchEvent(customEvent);
		}
 		
		if (row != oldrow) {
			const customEvent		= new CustomEvent(ninegrid.EVENT.ROW_POS_CHANGED, { bubbles: true, detail: {} });
	 		customEvent.col			= col;
			customEvent.cellIndex	= cellIndex;
	 		customEvent.row			= row;
			customEvent.subrow		= subrow;
			customEvent.bind		= cell.dataset.bind;
			customEvent.prev		= {
				col			: oldcol,
				cellIndex	: oldCellIndex,
	 			row			: oldrow,
				subrow		: oldsubrow,
				bind		: this.#oldBind,
			}
	 		
	 		this.#owner.dispatchEvent(customEvent);
		}
	};
	
	moveCell = (e) => {
		
		var td			= e.target.closest("th,td") || e.target.getRootNode().host.closest("th,td") || document.activeElement.closest("th,td")
		
		var tr			= td.closest("tr");
		var rowIndex	= tr.sectionRowIndex;
		var col			= parseInt(td.dataset.col);
		var row			= parseInt(tr.dataset.row);
		var matrixRow	= parseInt(tr.dataset.matrixRow);
		
		var nextElement;
		var nextMatrixRow;
		var nextCol;
		
		switch (e.code) {
			case "Tab":
			case "ArrowRight":
			case "ArrowLeft":
				nextMatrixRow = matrixRow;
				break;

			case "ArrowDown":
			case "ArrowUp":
			case "PageDown":
			case "PageUp":
				nextCol = col;
				break;
		}
		
		switch (e.code) {
			case "Tab":
				e.preventDefault();
				//nextCol = (e.shiftKey) ? this.#getPreviousCol(matrixRow, col) : col + (td.colSpan || 1);
				nextCol = (e.shiftKey) ? this.#getPreviousCol(matrixRow, col) : this.#getNextCol(matrixRow, col);
				break;
				
			case "ArrowRight":
				//nextCol = col + (td.colSpan || 1);
				nextCol = this.#getNextCol(matrixRow, col);
				break;
				
			case "ArrowLeft":
				nextCol = this.#getPreviousCol(matrixRow, col);
				break;

			case "ArrowDown":
				if (td.closest("tbody.fixed")) {
					nextMatrixRow = parseInt(td.dataset.matrixRow) + (td.rowSpan || 1);
				}
				else {
					const currRow = parseInt(td.dataset.row);
					const lastRow = this.#owner.view.getVisibleLastRow();
					const scroll = (this.#owner.isLastPage && currRow == lastRow-1 && $(".ng-container-body .nodata", this.#owner.shadowRoot).height() <= 0) ||
								(!this.#owner.isLastPage && this.#owner.lastRowHidden && currRow >= lastRow-1) ||
								(!this.#owner.isLastPage && !this.#owner.lastRowHidden && currRow >= lastRow);
					
					if (scroll) {
						this.#owner.scrollBy(1);
						
						this.currentCell = td;
						
						setTimeout(() => {
							td.focus();
						});
					}
					else {
						nextMatrixRow = parseInt(td.dataset.matrixRow) + (td.rowSpan || 1);
					}
				}
				break;
				
			case "ArrowUp":
				if (td.closest("tbody.fixed")) {
					nextMatrixRow = parseInt(td.dataset.matrixRow) - (td.rowSpan || 1);
				}
				else {
					if (td.closest("tr").sectionRowIndex == 0) {
						if (!this.#owner.isFirstPage) {
							this.#owner.scrollBy(-1);
			
							this.currentCell = td;
							setTimeout(() => {
								td.focus();
							});
						}
					}
					else {
						nextMatrixRow = parseInt(td.dataset.matrixRow) - (td.rowSpan || 1);
					}
				}
				break;

			case "PageDown":
				this.#owner.pageDown();
				break;
				
			case "PageUp":
				this.#owner.pageUp();
				break;
		}
		
		if (nextMatrixRow != null && nextCol != null && isFinite(nextMatrixRow)) {
			var el = this.#getNearElement(nextMatrixRow, nextCol);
			if (el && !el.querySelector("ng-row-indicator")) this.currentCell = el;
		}
		
		
		if (["Tab","ArrowLeft","ArrowRight"].includes(e.code)) {
			this.#owner.body.querySelector("ng-hscrollbar").refresh();
		}
	};
	
	#getPreviousCol = (matrixRow, col) => {
		var row = parseInt(matrixRow / this.#owner.template.length);
		
		var previousCol;// = $(`tbody tr[data-matrix-row=${matrixRow}]`, this.#owner.body).find("th,td").not(".dummy")
		
		$(`tbody tr[data-matrix-row=${matrixRow}]`, this.#owner.body).find("th,td").each((i,el) => {
			var elCol = parseInt(el.dataset.col);
			if ((col - 1) >= elCol && (col - 1) <= elCol + el.colSpan - 1) {
				previousCol = ninegrid.j.querySelectorAll(el).hasClass("dummy") ? this.#getPreviousCol(matrixRow, el.dataset.col) : el.dataset.col;
				return false;
			}
		});
		
		if (previousCol == null) {
			$(`tbody tr[data-row=${row}]`, this.#owner.body).find("th,td").each((i,el) => {
				var elCol = parseInt(el.dataset.col);
				if ((col - 1) >= elCol && (col - 1) <= elCol + el.colSpan - 1) {
					previousCol = ninegrid.j.querySelectorAll(el).hasClass("dummy") ? this.#getPreviousCol(matrixRow, el.dataset.col) : el.dataset.col;
					return false;
				}
			});
		}
		
		return previousCol;
	}
	
	#getNextCol = (matrixRow, col) => {
		var td = this.#owner.body.querySelector(`tbody [data-matrix-row="${matrixRow}"][data-col="${col}"]`);
		
		var nextCol = col + (td.colSpan || 1);
		var nextTd = this.#owner.body.querySelector(`tbody [data-matrix-row="${matrixRow}"][data-col="${nextCol}"]`);
		if (ninegrid.j.querySelectorAll(nextTd).hasClass("dummy")) {
			nextCol = this.#getNextCol(matrixRow, nextCol);
		}
		
		return nextCol;
	}
	
	#getNearElement = (matrixRow, col) => {

		var row = parseInt(matrixRow / this.#owner.template.length);
		
		var el = $(`[data-matrix-row=${matrixRow}][data-col=${col}]`, this.#owner.body).not(".dummy").filter(':visible');
		if (el.length == 0)  {
			el = $(`[data-row=${row}][data-col=${col}]`, this.#owner.body).not(".dummy").filter(':visible');
		}
		
		return el[0];
	}
	
	
	refresh = () => {
		this.#owner.selection.refresh();
	}
	
	//#wheelCount = 0;
	#onWheel = (e) => {

		if (e.altKey || e.shiftKey || e.ctrlKey) return;

		/** auto-height 일때는 이벤트전파가 되어야 스크롤됨 */
		if (this.#owner.getAttribute("auto-height") !== "true") e.preventDefault();
		
		if (e.originalEvent.deltaY > 0) {
			//this.#owner.pageDown();
			this.#owner.scrollBy(1);
		}
		else {
			//this.#owner.pageUp();
			this.#owner.scrollBy(-1);
		}
	};
	
	//#top = 0;
	#onMouseDown = (e) => {
		
		if (e.ctrlKey || e.altKey) return;
		
		if (e.target.tagName == "NG-ROW-INDICATOR" && [ninegrid.SELECTTYPE.CELL,ninegrid.SELECTTYPE.AREA].includes(this.#owner.selection.type)) return;
		
		if (e.shiftKey) {
			if ([ninegrid.SELECTTYPE.COLS,ninegrid.SELECTTYPE.ROWS,ninegrid.SELECTTYPE.AREA].includes(this.#owner.selection.type)) {
				var fromTD = this.#owner.selection.getActiveCell();
				if (fromTD) {
					var fromTR = fromTD.closest("tr");
					
					var startRow	= (parseInt(fromTD.dataset.row) * this.#owner.template.length + fromTR.sectionRowIndex % this.#owner.template.length);
					var startCol	= parseInt(fromTD.dataset.col);
					
					
					var toTD = e.target.closest("th,td");
					var toTR = toTD.closest("tr");
					
					var endRow	= (parseInt(toTD.dataset.row) * this.#owner.template.length + toTR.sectionRowIndex % this.#owner.template.length);
					var endCol	= parseInt(toTD.dataset.col);
		
					this.#owner.selection.selectArea(startRow, startCol, endRow, endCol);
				}
			}
		}
		else {
			const td		= e.target.closest("th,td");
			const lastRow	= this.#owner.view.getVisibleLastRow();//Math.max.apply(null, this.#owner.bindMatrixRows);
			const currRow	= parseInt(td.closest("tr").dataset.row);
			const isFixed	= td.closest("tbody.fixed") ? true : false;
			const nodata	= this.#owner.shadowRoot.querySelector(".ng-container-body tr.nodata");
			
			if (!isFixed && $(nodata).height() <= 0 && this.#owner.lastRowHidden && lastRow == currRow) {
				const matrixRow		= parseInt(td.closest("tr").dataset.matrixRow);
				const nextCol		= parseInt(td.dataset.col);

				this.#owner.scrollBy(1);
				
				const el = this.#getNearElement(matrixRow, nextCol);
				this.currentCell = el;
				setTimeout(() => {
					el.focus();
				});
			}
			else {
				this.currentCell = td;
			}
		}
	};
	
	
	#onKeyDown = (e) => {
		
		if (e.ctrlKey || e.altKey) return;

		//e.preventDefault();
		//e.stopPropagation();
		
		if (["TH","TD"].includes(e.target.tagName)) {
			if (["Tab","PageUp","PageDown","ArrowUp","ArrowDown","ArrowLeft","ArrowRight"].includes(e.code)) {
				e.preventDefault();
				this.moveCell(e);
			}
			else if (["Enter"].includes(e.code)) {
				e.preventDefault();
				const el = e.target.querySelector("ng-input");
				if (el) {
					const el2 = el.shadowRoot.querySelector("input[type=text]");
					el2.focus();
					el2.select();
				}
			}
			else {
				//e.preventDefault();
			}
		}
		else if (["NG-INPUT"].includes(e.target.tagName)) {
			if (["Enter"].includes(e.code)) {
				//e.preventDefault();
				//this.moveCell(e);
			}
			else {
				//e.preventDefault();
			}
		}
		else {
			
		}
	};
	
	resetEvent = () => {
		document.addEventListener('contextmenu', e => e.preventDefault());

		$(".ng-table tbody.bindable",	this.#owner.body).off("wheel",					this.#onWheel);
		$(".ng-table tbody",			this.#owner.body).off("keydown",	"th,td",	this.#onKeyDown);
		$(".ng-table tbody",			this.#owner.body).off("mousedown",	"th,td",	this.#onMouseDown);
		
		$(".ng-table tbody.bindable",	this.#owner.body).on("wheel",					this.#onWheel);
		$(".ng-table tbody",			this.#owner.body).on("keydown",		"th,td",	this.#onKeyDown);
		$(".ng-table tbody",			this.#owner.body).on("mousedown",	"th,td",	this.#onMouseDown);

		if (this.#owner.selection) this.#owner.selection.resetEvent();
	}
}
